import { Fragment, useEffect, useState } from "react"
import { count } from "../../config/helpers"

import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import dynamic from "next/dynamic";
import { useRouter } from "next/router";

const ArticleAccordion = dynamic(() => import('../../Custom/ArticleAccordion'));

const ArticleArchives = ({type, article_dates}) => {
    const [expanded, setExpanded] = useState(null);

    const handleChange = (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : null);
    };

    const router = useRouter();

    useEffect(() => {
        if(router?.query?.slug){
           const idx = article_dates.findIndex(article => article.year == router.query.slug)
           if(idx != -1){
                setExpanded(idx);
           }
        }
    }, [])

    return (
        <>
            <Typography color="primary" component="h5" variant="h5" className="text-start font-light f-size_4">Archives</Typography>
            <Divider className="mb-3 mt-2"/>

            {count(Object.keys(article_dates)) > 0 && article_dates.map((dates, idx) => {
                return (
                    <Fragment key={idx}>
                        <ArticleAccordion 
                            handleChange={handleChange}
                            expanded={expanded}
                            idx={idx}
                            year={dates.year}
                            months={dates.months}
                            type={type}
                        />
                    </Fragment>
                )
            })}
        </>
    )
}

export default ArticleArchives